export const InstagramCameraGiveawayPopup = {
  subtitle: 'Upgrade your creator kit'.toUpperCase(),
  mainTitle: 'Join our Instagram giveaway',
  imgSrc: 'https://cdn.uppbeat.io/instagram-camera-giveaway-december-2025.png',
  imgAlt: 'instagram camera giveaway',
  imgSrcCarousel:
    'https://cdn.uppbeat.io/instagram-camera-giveaway-december-2025.png',
  imgAltCarousel: 'Instagram camera giveaway annoucement banner',
  cta: 'Enter now',
  href: 'https://www.instagram.com/p/DSCz7arCCXw/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
  description:
    'You could win a GoPro HERO13 and 1 year subscription to Uppbeat Creator!',
};

export const TiktokCameraGiveawayPopup = {
  mainTitle: 'Join our TikTok giveaway',
  imgSrc: 'https://cdn.uppbeat.io/tiktok-camera-giveaway-sep-2025.png',
  imgAlt: 'tiktok camera giveaway',
  imgSrcCarousel: 'https://cdn.uppbeat.io/tiktok-camera-giveaway-sep-2025.png',
  imgAltCarousel: 'tiktok camera giveaway annoucement banner',
  cta: 'Enter now',
  href: 'https://www.tiktok.com/@uppbeat/video/7548787636853394710?is_from_webapp=1&sender_device=pc&web_id=7548782681270650390',
  description:
    'You could win a DJI Mini 4K Combo and 1 year subscription to Uppbeat Creator!',
};

export const TiktokGiveaway2026Popup = {
  mainTitle: 'Join our TikTok giveaway',
  imgSrc: 'https://cdn.uppbeat.io/tiktok-giveaway-2026.jpg',
  imgAlt: 'TikTok giveaway 2026',
  imgSrcCarousel: 'https://cdn.uppbeat.io/tiktok-giveaway-2026.jpg',
  imgAltCarousel: 'TikTok giveaway 2026 announcement banner',
  cta: 'Enter now',
  href: 'https://www.tiktok.com/@uppbeat/video/7602994392437230870?is_from_webapp=1&sender_device=pc&web_id=7602989771578639895',
  description:
    'You could win a Insta360 X4 and 1 year subscription to Uppbeat Creator!',
};

export const InstagramMicMiniGiveaway2026Popup = {
  subtitle: 'Win an audio upgrade'.toUpperCase(),
  mainTitle: 'Join our Instagram giveaway',
  imgSrc: 'https://cdn.uppbeat.io/images/instagram-ga-june-26.png',
  imgAlt: 'Instagram mic mini giveaway',
  imgSrcCarousel: 'https://cdn.uppbeat.io/images/instagram-ga-june-26.png',
  imgAltCarousel: 'Instagram mic mini giveaway announcement banner',
  cta: 'Enter now',
  href: 'https://www.instagram.com/reel/DZ9-Jd_Itb-/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
  description:
    "We're giving 5 lucky winners a DJI Mic Mini and a 1 year subscription to Uppbeat Pro!",
};

export const AiSurvey2026Popup = {
  subtitle: 'Complete the survey'.toUpperCase(),
  mainTitle: 'Shape the future of creative tools',
  imgSrc: 'https://cdn.uppbeat.io/survey-pop-up-img-feb-26.jpg',
  imgAlt: 'AI creativity survey',
  imgSrcCarousel: 'https://cdn.uppbeat.io/survey-pop-up-img-feb-26.jpg',
  imgAltCarousel: 'AI creativity survey announcement banner',
  cta: 'Take the survey',
  href: 'https://uppbeat.typeform.com/to/pd29W5Te',
  description:
    'Share your perspective on AI in creativity in 2026 and you could win a $500 Amazon giftcard + Uppbeat Pro.',
};

export const GenericCouponPopupCopy = {
  subtitle: 'DISCOUNT UNLOCKED',
  mainTitle: 'Your coupon is active',
  description:
    'Sweet! Your discount will be automatically applied at checkout.',
  cta: 'Explore plans',
  href: '/pricing',
};

export const FailedPaymentPopup = {
  subtitle: 'FAILED PAYMENT',
  mainTitle: "We couldn't process your latest payment",
  imgSrc: 'https://cdn.uppbeat.io/creators-cut-x5-camera-prize.jpg',
  imgAlt: 'instagram camera giveaway',
  imgSrcCarousel: 'https://cdn.uppbeat.io/creators-cut-x5-camera-prize.jpg',
  imgAltCarousel: 'Instagram camera giveaway annoucement banner',
  cta: 'Update payment method',
  href: 'https://www.instagram.com/p/DMNpKstIDFk/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
  description:
    'Your subscription is currently on hold. To regain full access to your subscription benefits, update your payment details.',
};

export const InstagramMonthlyGiveaway2026Popup = {
  subtitle: 'Join our Instagram giveaway'.toUpperCase(),
  mainTitle: 'Win 5 years of Uppbeat Pro',
  imgSrc: 'https://cdn.uppbeat.io/images/instagram-5-years-giveaway-sep-26.jpg',
  imgAlt: 'Instagram monthly giveaway',
  cta: 'Enter now',
  href: 'https://www.instagram.com/reel/DdZBS1FqX97/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==',
  description:
    'Every month, we’re giving one Instagram follower 5 years of Uppbeat Pro for free. Follow us for your chance at winning!',
};

export const LiminalAmbientDeepDivePopup = {
  mainTitle: 'Want to learn more about liminal music?',
  imgSrc: 'https://cdn.uppbeat.io/images/deep-dives.png',
  imgAlt: 'Uppbeat deep dives',
  description: 'Check out our liminal aesthetics deep dive on Instagram!',
  cta: 'View on Instagram',
  href: 'https://www.instagram.com/p/DQ4kyoDiPyG/',
};
